import { Observable } from 'rxjs';
import type { BalanceDto } from '@coin-depo-types';

export interface BalancesFacadeBase {
  cachedBalances$: Observable<BalanceDto[]>;
  cachedTotalBalance$: Observable<number>;

  updateBalances(
    currency?: string,
    waiteUntil?: Observable<any>
  ): Observable<any>;
}

export interface BalancesFacade extends BalancesFacadeBase  {
  // credits
  cachedAvailableCreditLimit$: Observable<number>;
  cachedCreditLineLimit$: Observable<number>;

  // referrals
  cachedEarnedReferrals$: Observable<number>;

  // bonuses
  cachedBonusesPending$: Observable<string>;
  cachedBonusesPaid$: Observable<string>;

  // token
  cachedTokenAdvantage$: Observable<{
    balance: number;
    balance_currency: number;
    coindepo_percentage: string;
    tier_id: number;
  } | null>;

  changeAccountVisibility(
    planId: string,
    walletName: string,
    visible?: number
  ): Observable<true | string>;
}